import React from 'react';

import Container from '@/components/Container';

import * as styled from './Layout.styled';

export const Layout: React.FC<{ $flexGrow?: boolean }> = ({
  children,
  $flexGrow,
}) => (
  <styled.Main $flexGrow={$flexGrow}>
    <Container $flexGrow>
      <styled.Body>{children}</styled.Body>
    </Container>
  </styled.Main>
);
